export default "__VITE_ASSET__fxbG2uzt__";